import { Link as ChakraLink } from '@chakra-ui/react';
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from '~/packages/common-frontend/colors';

type LinkProps = { children: React.ReactNode; to: string } & ChakraLinkProps;
export const Link = ({ children, to, ...chakraLinkProps }: LinkProps) => {
  return (
    <ChakraLink
      {...chakraLinkProps}
      as={RouterLink}
      to={to}
      fontWeight={chakraLinkProps.fontWeight || '500'}
      color={chakraLinkProps.color || colors.info}
    >
      {children}
    </ChakraLink>
  );
};
